<template>
  <div class="userStatistic">
    <pageTitle />
    <div class="page-main">
      <div class="numTip-wrap">
        <p class="numTip">
          <span class="numTip-value" v-text="_totalAccountNum" />
          <span class="numTip-name">总设备数</span>

        </p>
        <p class="numTip">
          <span class="numTip-value" v-text="_curMonthAddedAccount" />
          <span class="numTip-name">本月激活设备</span>
        </p>
      </div>
      <mLine class="h300" v-if="changeShow" :option="Option" />
    </div>
    <a-row :gutter="20">
      <a-col class="gutter-row" :span="12">
        <m-pie :data="pie" :option="pieOption" class="h300 page-main" />
      </a-col>
      <a-col class="gutter-row" :span="12">
        <m-pie :data="pie1" :option="{...pieOption, title: { text: '设备类型', left: 'left'}}" class="h300 page-main" />
      </a-col>
      <a-col class="gutter-row" :span="12">
        <m-pie :data="pie2" :option="{...pieOption, title: { text: '设备型号', left: 'left'}}" class="h300 page-main" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import mPie from "@/components/business/echartsComponents/mPie";
import mLine from "@/components/business/echartsComponents/mLine";
import { deviceType } from "@/utils/pageMaps";

export default {
  name: "equipment",
  components: {
    pageTitle,
    mPie,
    mLine
  },
  data() {
    return {
      pie: [],
      pie1: [],
      pie2: [],
      allData: {},
      show: false,
      Option: {
        grid: {
          left: "3%",
          right: "4%",
          top: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
          axisLabel: {
            color: "#999"
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#999"
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            type: "line",
            data: []
          }
        ]
      },
      pieOption: {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}"
        },
        title: {
          text: "设备状态",
          left: "left"
        }
      },
      pieOption1: {
        title: {
          text: "用户所在行业排名",
          left: "left"
        }
      },
      dataUrl: 'bluetoothlight/web/statistics/device',
      codeMaps: {
        ...deviceType.enumerate,
        "NONACTIVATED": '未激活',
        "UNBOUND": '已解绑',
        "BINDING": '绑定中',
        // "WHITE_LIGHT": '白光',
        // "RGB": 'RGB',
        "TWO_COLOR_TEMPERATURE": '双色温',
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData: async function() {
      const res = await this.$get(this.dataUrl);
      console.log(res);
      const resultStatus = res?.resultStatus;
      if (!resultStatus) return false;
      const data = res?.resultData;
      this.allData = data;

      const devicePeriodStatistics = data?.devicePeriodStatistics;
      if (this.verifyData(devicePeriodStatistics)) {

        const { Option } = this;
        const {xAxis} = Option;
        this.Option = {
          ...Option,
          xAxis: {
            ...xAxis,
            type: "category",
            data: devicePeriodStatistics.map(el => el?.totalDate)
          },
          series: [
            {
              name: "近30天激活",
              type: "line",
              emphasis: {
                focus: "series"
              },
              data: devicePeriodStatistics?.map(el => el?.activateNum) || []
            }
          ]
        };
      }
      const deviceStatusStatistics = data?.deviceStatusStatistics;
      if (this.verifyData(deviceStatusStatistics)) {
        this.pie = deviceStatusStatistics.map(({ deviceStatus, deviceNum }, index) => ({
          index: index + 1,
          value: deviceNum,
          name: this.codeMaps[deviceStatus]
        }));
      }
      const deviceTypeStatistics = data?.deviceTypeStatistics;
      if (this.verifyData(deviceTypeStatistics)) {
        this.pie1 = deviceTypeStatistics.map(({ deviceType, deviceNum }, index) => ({
          index: index + 1,
          value: deviceNum,
          name: this.codeMaps[deviceType]
        }));
      }
      const deviceModelStatistics = data?.deviceModelStatistics;
      if (this.verifyData(deviceModelStatistics)) {
        this.pie2 = deviceModelStatistics.map(({ deviceModel, deviceNum }, index) => ({
          index: index + 1,
          value: deviceNum,
          name: deviceModel
        }));
      }
    },
    verifyData(data) {
      return data && data.length;
    },
    rowClassName(record, index) {
      let className = "";
      if (index % 2 === 1) className = "tableBg";
      return className;
    }

  },
  computed: {
    _totalAccountNum() {
      return this?.allData?.summaryStatistics?.totalDeviceNum || 0;
    },
    _curMonthAddedAccount() {
      return this?.allData?.summaryStatistics?.curMonthActiveNum || 0;
    },
    changeShow() {
      return this.Option.series?.[0]?.data?.length
    }
  }
};
</script>

<style lang="less">
.tableBg {
  background-color: rgba(0, 0, 0, .06);
}

.h300 {
  height: 300px !important;
}
.numTip-value {
  color: #FF5B5B
}
</style>
